import { createApp } from 'vue';
import store from '@/store';
import App from './App.vue';

import 'aos/dist/aos.css';

createApp(App)
    .use(store)
    .mount('#app');
